<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="queryParams.toDate"></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                name="trialBalanceCode"
                label="Trial Balance Code"
                type="text"
                v-model="queryParams.trialBalanceCode"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 v-if="this.user.role.roleName != 'BRANCH_ADMIN'">
              <shop-autocomplete
                :param="Number(queryParams.shopId)"
                @set="setShop"
              />
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="statusList"
                label="Choose Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="trialBalanceList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
          <template slot="items" slot-scope="props">
              <td>
                <v-btn
                  @click="getTrialBalanceDetail(props.item.id)"
                  color="primary"
                  >DETAIL</v-btn
                >
              </td>
              <td>{{ props.item.status }}</td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.shopCode }}</td>
              <td>{{ props.item.year }}</td>
              <td>{{ props.item.month }}</td>
              <td>
                {{
                  props.item.createdDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.createdBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="text-xs-center">
      <v-dialog v-model="dialog" persistent max-width="360">
        <v-card>
          <v-card-title class="headline green lighten-2"
            >Confimation Trial Balance</v-card-title
          >
          <v-card-text>{{ responseMessage }}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="dialogDisabled"
              flat
              @click="dialog = false"
              >OK</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- Trial print hidden area -->
    <!-- <trial id="trialPrint"></invoice> -->
    <div
      id="trialPrint"
      style="bsale: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center; padding-bottom: 5px">
        <p style="font-size: 15px; margin: 0px; font-weight: bold">
          Trial Balance
        </p>
      </div>

      <div style="text-align: center">
        <p style="font-size: 15px; margin: 0px"></p>
      </div>
      <div style="float: left; padding-left: 11px">
        <p style="font-size: 15px; margin: 0px" id="counter">
          Trial Balance Code : {{ trialBalance.code }}
        </p>
      </div>
      <div style="float: right; padding-right: 11px">
        <p style="font-size: 15px; margin: 0px" id="counter">
          Account Type : {{ trialBalance.trialBalanceType }}
        </p>
      </div>
      <br />
      <div style="float: left; padding-left: 11px">
        <p style="font-size: 15px; margin: 0px" id="counter">
          Shop Code: {{ trialBalance.shopCode }}
        </p>
      </div>
      <div style="float: right; padding-right: 11px">
        <p style="font-size: 15px; margin: 0px" id="counter">
          Created Date :
          {{
            trialBalance.createdDateInMilliSeconds | format-ms-date-time
          }}
        </p>
      </div>
      <br />
      <div style="float: left; padding-left: 11px">
        <p style="font-size: 15px; margin: 0px" id="casher">
          Balance Month: {{ trialBalance.month }} {{ trialBalance.year }}
        </p>
      </div>
      <div style="float: right; padding-right: 11px">
        <p style="font-size: 15px; margin: 0px" id="counter">
          Created By : {{ trialBalance.createdBy }}
        </p>
      </div>
      <br />
      <div style="float: left; padding-left: 11px; padding-top: 5px">
        <p style="font-size: 15px; margin: 0px; font-weight: bold" id="casher">
          Summary Of Active Accounts
        </p>
      </div>
      <div style="clear: both"></div>
      <div style="height: 10px"></div>
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 11px;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr style="line-height: 20px">
              <th style="border: 1px solid black; text-align: center">
                Account Code
              </th>
              <th style="border: 1px solid black; text-align: center">
                Account Name
              </th>
              <th style="border: 1px solid black; text-align: center">
                Account Head
              </th>
              <th style="border: 1px solid black; text-align: center">Debit</th>
              <th style="border: 1px solid black; text-align: center">Credit</th>
            </tr>
          </thead>
          <tbody v-for="(item, index) in trialBalance.trialBalanceDetailList"
              :key="index">
            <tr v-if="!item.chartOfAccount.isHide"
              style="line-height: 20px"
            >
              <td style="border: 1px solid black; text-align: center">
                <span>{{ item.chartOfAccount.code }}</span>
              </td>
              <td style="border: 1px solid black; text-align: left">
                <span>{{ item.chartOfAccount.accName }}</span>
              </td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.chartOfAccount.accounthead.accountName }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                   <span v-if="item.chartOfAccount.nature =='DR' && item.chartOfAccount.carryOn && item.chartOfAccount.previousTrial">
                      {{ item.openingBalance | decFormat(6) }} </span>
                   <span v-else-if="item.chartOfAccount.nature =='DR'">
                      {{ item.closingBalance | decFormat(6) }} </span>
              </td>
              <td style="border: 1px solid black; text-align: right">
                   <span v-if="item.chartOfAccount.nature =='CR' && item.chartOfAccount.carryOn && item.chartOfAccount.previousTrial">
                      {{ item.openingBalance | decFormat(6) }} </span>
                    <span v-else-if="item.chartOfAccount.nature =='CR'">
                      {{ item.closingBalance | decFormat(6) }} </span> 
              </td>
            </tr>
            </tbody>
            <tr style="line-height: 20px">
              <td colspan="3" style="border: 1px solid black">Total</td>
              <td style="border: 1px solid black; text-align: right">
                {{ trialBalance.totalDebitAmount | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ trialBalance.totalCreditAmount | decFormat(6) }}
              </td>
            </tr>
        </table>
        <div style="height: 10px"></div>
      </div>
    </div>
    <!-- End print  -->

    <!-- Trial Balance Details dialog -->
    <v-dialog
      v-model="showTrialBalanceDetailsDialog"
      scrollable
      max-width="1000px"
    >
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Search"
                type="text"
                class="mr-1"
                v-model="accountName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <div>
                <v-btn color="primary" @click="print()">PRINT</v-btn>
                <v-btn color="primary" @click="exportAll()">EXPORT</v-btn>
                <v-btn
                  color="primary"
                  @click="confirm()"
                  :disabled="trialBalanceStatus == 'DRAFT' ? false : true"
                  >CONFIRM</v-btn
                >
              </div>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Customer List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="tbHeaders"
                :items="trialBalanceDetailList"
                class="elevation-1"
                :loading="showTrialBalanceListLoading"
                :total-items="tbTotalRows"
                :rows-per-page-items="tbRowsPerPageItems"
                :pagination.sync="tbPagination"
                :must-sort="true"
                :search="accountName"
              >
                <template slot="items" slot-scope="props">
                  <tr v-if="!props.item.chartOfAccount.isHide">
                  <td>{{ props.item.chartOfAccount.code }}</td>
                  <td>{{ props.item.chartOfAccount.accName }}</td>
                  <td>
                    {{ props.item.chartOfAccount.accounthead.accountName }}
                  </td>
                  <td style="text-align: right">
                   <span v-if="props.item.chartOfAccount.nature =='DR' && props.item.chartOfAccount.carryOn && props.item.chartOfAccount.previousTrial">
                      {{ props.item.openingBalance | decFormat(6) }} </span>
                   <span v-else-if="props.item.chartOfAccount.nature =='DR'">
                      {{ props.item.closingBalance | decFormat(6) }} </span>
                  </td>
                  <td style="text-align: right">
                    <span v-if="props.item.chartOfAccount.nature =='CR' && props.item.chartOfAccount.carryOn && props.item.chartOfAccount.previousTrial">
                      {{ props.item.openingBalance | decFormat(6) }} </span>
                    <span v-else-if="props.item.chartOfAccount.nature =='CR'">
                      {{ props.item.closingBalance | decFormat(6) }} </span>
                  </td>
                  </tr>
                </template>
                <template slot="footer">
                  <td colspan="3">Total</td>
                  <td style="text-align: right">{{ totalDebitAmount | decFormat(6) }}</td>
                  <td style="text-align: right">{{ totalCreditAmount | decFormat(6) }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- confrim dialog for reverse process-->
    <v-dialog
      v-model="confirmBox"
      max-width="500px"
      @keydown.enter="onConfirm()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to confirm this trial balance?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="confirmBox = false">No</v-btn>
          <v-btn
            color="success"
            large
            outline
            @click="onConfirm(), (confirmBox = false)"
            >yes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import ShopAutocomplete from "../templates/ShopAutocomplete.vue";
import { trialBalanceService } from "../../services/trial-balance-service";
import { TrialBalance } from "../../models/model";
import { commonService } from "../../services/common-service";

export default {
  name: "TrialBalanceList",
  components: { ShopAutocomplete },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showListLoading: false,
    dialog: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Trial Balance",
        disabled: true,
      },
    ],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Status", value: "status" },
      { text: "Trial Balance Code", align: "left", value: "code" },
      { text: "Shop Code", value: "shopCode" },
      { text: "Year", value: "year" },
      { text: "Month", value: "month" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" },
    ],
    tbHeaders: [
      { text: "Account Code", value: "chartOfAccount.code", sortable: false },
      {
        text: "Account Name",
        value: "chartOfAccount.accName",
        sortable: false,
      },
      { text: "Account Head", value: "accounthead", sortable: false },
      { text: "Debit", value: "debit", align: "center", sortable: false },
      { text: "Credit", value: "credit", align: "center", sortable: false },
    ],
    rowsPerPageItems: [25, 50, 100],
    tbRowsPerPageItems: [25, 50, 100],
    tbTotalRows: 0,
    tbPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0,
    },
    decimalFormat: "",
    responseMessage: "",
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0,
    },
    trialBalanceList: [],
    trialBalanceDetailList: [],
    statusList: [
      { label: "---All---", value: "" },
      { label: "DRAFT", value: "DRAFT" },
      { label: "CONFIRM", value: "CONFIRM" },
    ],
    totalRows: 0,
    showTrialBalanceListLoading: false,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      trialBalanceCode: "",
      shopCode: "",
      shopId: "",
      status: "",
    },
    accountName: "",
    trialBalanceId: "",
    trialBalanceStatus: "",
    totalDebitAmount: "",
    totalCreditAmount: "",
    totalDifferentAmount: "",
    trialBalance: new TrialBalance(),
    showTrialBalanceDetailsDialog: false,
    confirmBox: false,
    dialogDisabled: false,
    exportLoading: false,
  }),
  watch: {
    pagination: {
      handler() {
        this.getTrialBalanceList();
      },
      deep: true,
    },
  },

  created() {
    //for deep linking
    if (this.$route.query.fromDate) {
      this.queryParams.fromDate = this.$route.query.fromDate;
    }
    if (this.$route.query.toDate) {
      this.queryParams.toDate = this.$route.query.toDate;
    }
    if (this.$route.query.trialBalanceCode) {
      this.queryParams.trialBalanceCode = this.$route.query.trialBalanceCode;
    }
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.shopCode) {
      this.queryParams.shopCode = this.$route.query.shopCode;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.decimalFormat = commonService.formatdecimal();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "trial-balances", query: this.queryParams });
      this.getTrialBalanceList();
    },
    getTrialBalanceList() {
      this.showListLoading = true;
      if (this.user.role.roleName == "BRANCH_ADMIN") {
        this.queryParams.shopCode = this.user.shop.code;
      }
      let order = this.pagination.descending ? "desc" : "asc";
      trialBalanceService
        .getTrialBalanceList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.trialBalanceList = res.data.trialBalanceList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/trial-balance/new");
    },
    onEdit(trialBalance) {
      // go to details page
      this.$router.push("/trial-balance/" + trialBalance.id);
    },
    exportAll() {
      this.exportLoading = true;
      trialBalanceService
        .exportTrialBalanceById(this.trialBalanceId)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.exportLoading = false;
        });
    },
    print() {
      trialBalanceService
        .getTrialBalanceById(this.trialBalanceId)
        .then((res) => {
          this.trialBalance = res.data;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.printInvoice("trialPrint");
        });
    },
    printInvoice(divName) {
      var printContents = document.getElementById(divName).innerHTML;

      // var originalContents = document.body.innerHTML;
      var myWindow = window.open("", "MsgWindow", "width=350,height=500");
      myWindow.document.write(printContents);

      // document.body.innerHTML = printContents;
      myWindow.print();

      // document.body.innerHTML = originalContents;
      myWindow.close();
    },

    getTrialBalanceDetail(id) {
      this.trialBalanceId = id;
      trialBalanceService
        .getTrialBalanceById(id)
        .then((res) => {
          this.trialBalanceDetailList = res.data.trialBalanceDetailList;
          this.totalDebitAmount = res.data.totalDebitAmount;
          this.totalCreditAmount = res.data.totalCreditAmount;
          this.totalDifferentAmount = res.data.totalDifferentAmount;

          this.trialBalanceStatus = res.data.status;
          this.showTrialBalanceDetailsDialog = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    confirm() {
      this.confirmBox = true;
    },
    onConfirm() {
      this.isLoading = true;
      this.dialog = true;
      this.responseMessage = "Loading Confirmation.....";
      this.dialogDisabled = true;
      trialBalanceService
        .confirmTrialBalane(this.trialBalanceId)
        .then((res) => {
          if (res.data) {
            this.responseMessage = "Confirmation Success";
            this.dialogDisabled = false;
          }
        })
        .catch((err) => {
          this.dialogDisabled = false;
          if (err.response.data) {
            this.responseMessage = err.response.data.message;
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.dialog = true;
          this.dialogDisabled = false;
          this.showTrialBalanceDetailsDialog = false;
          this.getTrialBalanceList();
        });
    },

    setShop(obj) {
      this.queryParams.shopCode = obj.shopCode;
      this.queryParams.shopId = obj.shopId;
    },
  },
};
</script>